import {keyCombo} from "./key-combo";
import {remove1Mutate} from "../utils/collections";

const listeners = [];

const listener = (e) => {

    if (~["INPUT", "TEXTAREA", "SELECT"].indexOf(e.target.nodeName) && e.key === "Escape") {
        // e.target.value = "";
        e.target.blur();
        return;
    }

    for (let i = listeners.length - 1; i > -1; i--) {

        const listener = listeners[i];

        if (!~["INPUT", "TEXTAREA", "SELECT"].indexOf(e.target.nodeName) && listener.check(e)) {

            listener.invoke(e);
            e.preventDefault();
            e.stopPropagation();
            return;
        }
    }
};

window.addEventListener("keydown", listener);

export const globalKeys = {
    onKeyDown: (check, invoke) => {
        if (typeof check === "string") {
            check = keyCombo(check);
        }

        const listener = {check, invoke};
        listeners.push(listener);
        return () => remove1Mutate(listeners, listener);
    },
};
